<template>
  <div class="info">
    <Header :title="{name: '个人信息'}"></Header>
    <ul>
      <li @click="onChangeInfo('avatar')">
        <span>头像</span>
        <span>
          <img :src="userInfo.avatar" />
        </span>
      </li>
      <li @click="onChangeInfo('nickname')">
        <span>昵称</span>
        <span>{{userInfo.nickname}}</span>
      </li>
      <li class="mobile">
        <span>手机号</span>
        <span>{{userInfo.mobile}}</span>
      </li>
      <li @click="onChangeInfo('sex')">
        <span>性别</span>
        <span>{{userInfo.sex_name}}</span>
      </li>
      <li @click="onChangeInfo('birthday')">
        <span>出生日期</span>
        <span>{{userInfo.birthday}}</span>
      </li>
      <li @click="onChangeInfo('address')">
        <span>所在城市</span>
        <span>{{userInfo.province_name}}{{userInfo.city_name?","+userInfo.city_name:''}}{{userInfo.district_name?","+userInfo.district_name:''}}</span>
      </li>
      <li v-for="(item, index) in attrs" :key="index" @click="onChangeInfo('attrs', item)">
        <span>{{item.attr}}</span>
        <span
          v-if="item.type == 1"
        >{{item.selectIdx.length == 0 ? '请选择' : item.value[item.selectIdx[0]].text}}</span>
        <span v-else>{{getAttrsSelectExtendText(item)}}</span>
      </li>
    </ul>
    <van-popup v-model="showPopup" position="bottom">
      <ul v-if="changeTag == 'avatar'" class="popup">
        <li @click="onAppUploadImg(1)">
          拍照
          <input
            v-if="!$store.state.app"
            type="file"
            accept="image/*"
            capture="camera"
            @change="onChangeAvatar"
          />
        </li>
        <li @click="onAppUploadImg(2)">
          从手机相册选择
          <input
            v-if="!$store.state.app"
            type="file"
            accept="image/*"
            @change="onChangeAvatar"
          />
        </li>
        <li @click="onCancel">取消</li>
      </ul>
      <van-datetime-picker
        v-else-if="changeTag == 'birthday'"
        v-model="birthday.currentDate"
        type="date"
        :min-date="birthday.minDate"
        :max-date="birthday.maxDate"
        @cancel="onCancel"
        @confirm="onConfirmBirthday"
      />
      <van-area
        v-else-if="changeTag == 'address'"
        :area-list="areaList"
        :columns-num="3"
        @change="onChangeAddress"
        @cancel="onCancel"
        @confirm="onConfirmAddress"
        :value="userInfo.district_id + ''"
      />
      <div v-if="changeTag == 'attrs'">
        <van-picker
          v-if="attrsType == 1"
          :columns="attrsColums"
          :default-index="attrsSelect"
          show-toolbar
          @cancel="onCancel"
          @confirm="onConfirmAttrs"
        />
        <div v-else-if="attrsType == 2" class="attrs-checkbox">
          <div class="attrs-checkbox-btn">
            <p @click="onCancel">取消</p>
            <p @click="onConfirmAttrsExtend">确认</p>
          </div>
          <div class="attrs-checkbox-content">
            <van-checkbox-group v-model="attrsSelectExtend">
              <van-checkbox
                v-for="(item, index) in attrsColums"
                :key="index"
                :name="item.id"
              >{{item.name}}</van-checkbox>
            </van-checkbox-group>
          </div>
        </div>
      </div>
    </van-popup>
  </div>
</template>

<script>
import Header from "@/components/Header";
import { SexType } from "@/util/enums";
export default {
  name: "info",
  components: {
    Header
  },
  data() {
    return {
      userInfo: {},
      showPopup: false,
      changeTag: "",
      birthday: {
        minDate: new Date(1901, 1, 1),
        maxDate: new Date(),
        currentDate: new Date()
      },
      areaList: {
        province_list: {},
        city_list: {},
        county_list: {}
      },
      attrs: [],
      attrsColums: [],
      attrsSelect: -1, // 单选选中，这里为 index 数组
      attrsSelectExtend: [], // 错选选中，这里为 id 数组
      attrsType: -1,
      attrsRequired: false
    };
  },
  created() {
    this.requestUserInfo();
    // 注册连接app的方法
    setTimeout(() => {
      let _this = this;
      this.$pub.registerWebViewJavascriptBridge(function(data) {
        _this.requestUpdateUserInfo({ avatar: JSON.parse(data)[0].path });
      });
    }, 500);
  },
  methods: {
    // on event
    onChangeInfo(tag, item) {
      switch (tag) {
        case "nickname":
          this.$router.push({
            name: "SetInfo",
            query: {
              tag,
              value: this.userInfo.nickname
            }
          });
          return;
        case "sex":
          this.$router.push({
            name: "SetInfo",
            query: {
              tag,
              value: this.userInfo.sex
            }
          });
          return;
        case "address":
          this.requestArea();
          break;
        case "attrs":
          this.attrsColums = item.value;
          this.attrsType = item.type;
          this.attrsRequired = item.is_required;
          if (item.type == 1) {
            // 单选
            this.attrsSelect =
              item.selectIdx.length == 0 ? -1 : item.selectIdx[0];
          } else {
            // 多选
            const ary = [];
            item.selectIdx.forEach(i => {
              ary.push(item.value[i].id);
            });
            this.attrsSelectExtend = ary;
          }
          break;
      }
      this.changeTag = tag;
      this.showPopup = true;
    },
    onAppUploadImg(type) {
      if (this.$store.state.app) {
        this.$pub.appAction("selectPhoto", { photoType: type });
        this.showPopup = false;
      }
    },
    onChangeAvatar(e) {
      const formdata = new FormData();
      formdata.append("file", e.target.files[0]);
      this.$http.post("/api/app/public/img", formdata).then(data => {
        this.requestUpdateUserInfo({ avatar: data.path });
      });
      this.showPopup = false;
    },
    onCancel() {
      this.showPopup = false;
    },
    onConfirmBirthday(val) {
      this.showPopup = false;
      this.requestUpdateUserInfo({ birthday: val.format("yyyy-MM-dd") });
    },
    async onChangeAddress(picker, data, index) {
      switch (index) {
        case 0: // province
          {
            const province = await this.$http.get(
              `/api/app/sonArea/${data[index].code}`
            );
            let obj = {};
            province.forEach(i => {
              obj[i.id] = i.area_name;
            });
            this.areaList.city_list = obj;
            const city = await this.$http.get(
              `/api/app/sonArea/${province[0].id}`
            );
            obj = {};
            city.forEach(i => {
              obj[i.id] = i.area_name;
            });
            this.areaList.county_list = obj;
          }
          break;
        case 1: // city
          {
            const city = await this.$http.get(
              `/api/app/sonArea/${data[index].code}`
            );
            let obj = {};
            city.forEach(i => {
              obj[i.id] = i.area_name;
            });
            this.areaList.county_list = obj;
          }
          break;
        case 2: // county
          break;
      }
    },
    onConfirmAddress(val) {
      this.showPopup = false;
      this.requestUpdateUserInfo({
        province_id: val[0].code,
        city_id: val[1].code,
        district_id: val[2].code
      });
    },
    onConfirmAttrs(value, index) {
      this.showPopup = false;
      this.attrs[value.parentIdx].selectIdx = [index];
      this.updateAttrs();
    },
    onConfirmAttrsExtend() {
      // check
      if (this.attrsRequired && !this.attrsSelectExtend.length) {
        this.$toast("该属性为必填，请选择");
        return;
      }
      // process
      this.showPopup = false;
      const ary = [];
      this.attrsSelectExtend.forEach(i => {
        for (const columsIdx in this.attrsColums) {
          if (this.attrsColums[columsIdx].id == i) {
            ary.push(columsIdx);
            break;
          }
        }
      });
      this.attrs[this.attrsColums[0].parentIdx].selectIdx = ary;
      this.updateAttrs();
    },
    // other
    updateAttrs() {
      const attrAry = [];
      this.attrs.forEach(i => {
        if (i.selectIdx.length == 0) return;
        i.selectIdx.forEach(selecti => {
          attrAry.push({
            attr_id: i.id,
            attr_val_id: i.value[selecti].id
          });
        });
      });
      this.requestUpdateUserInfo({
        user_attr: JSON.stringify(attrAry)
      });
    },
    getAttrsSelectExtendText(item) {
      if (item.type != 2) return "";
      if (!item.selectIdx.length) return "请选择";
      let ret = [];
      item.selectIdx.forEach(i => {
        ret.push(item.value[i].text);
      });
      return ret.join();
    },
    // request
    requestUserInfo() {
      this.$http.get("/api/app/userInfo").then(data => {
        this.userInfo = data;
        // 性别
        this.userInfo.sex_name = SexType.getValue(data.sex);
        // 生日
        if (this.userInfo.birthday == 0) {
          this.userInfo.birthday = "请选择";
        }
        // 城市
        if (!this.userInfo.province_name) {
          this.userInfo.province_name = "请选择";
        }
        // 动态属性
        this.attrs = [];
        this.$http.get("/api/app/module/attribute/1").then(attrData => {
          attrData.forEach(i => {
            if (i.value.length == 0) return;
            // 修改
            i.value.forEach(ci => {
              ci.text = ci.name;
              ci.parentIdx = this.attrs.length;
            });
            // 选中
            i.selectIdx = [];
            for (const attri of this.userInfo.attr) {
              if (attri.attr_id == i.id) {
                for (let vali = 0; vali < i.value.length; ++vali) {
                  if (attri.attr_val_id == i.value[vali].id) {
                    i.selectIdx.push(vali);
                    break;
                  }
                }
              }
            }
            // 压入
            this.attrs.push(i);
          });
        });
        // console.log(this.attrs)
        this.showPopup = false;
      });
    },
    requestUpdateUserInfo(params) {
      this.$http.put("/api/app/user", params).then(() => {
        this.$toast("数据更新成功");
        this.requestUserInfo();
      });
    },
    async requestArea() {
      let obj = {};
      const province = await this.$http.get("/api/app/sonArea/0");
      province.forEach(i => {
        obj[i.id] = i.area_name;
      });
      this.areaList.province_list = obj;
      const provinceID = this.userInfo.province_id || province[0].id;
      const city = await this.$http.get(`/api/app/sonArea/${provinceID}`);
      obj = {};
      city.forEach(i => {
        obj[i.id] = i.area_name;
      });
      this.areaList.city_list = obj;
      const cityID = this.userInfo.city_id || city[0].id;
      const district = await this.$http.get(`/api/app/sonArea/${cityID}`);
      obj = {};
      district.forEach(i => {
        obj[i.id] = i.area_name;
      });
      this.areaList.county_list = obj;
      if (!this.userInfo.district_id && district.length) {
        this.userInfo.district_id = district[0].id;
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.info {
  @extend %default-bg;
  ul {
    background: #fff;
    margin: 20px 0;
    padding: 10px 30px;
    li {
      height: 110px;
      line-height: 110px;
      display: flex;
      justify-content: space-between;
      position: relative;
      span:nth-child(1) {
        font-size: 28px;
        color: #595959;
        display: inline-block;
        text-align: left;
        width: 340px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }
      span:nth-child(2) {
        font-size: 28px;
        color: #8c8c8c;
        margin-right: 30px;
        display: inline-block;
        text-align: right;
        width: 270px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }
      span > img {
        width: 74px;
        height: 74px;
        border-radius: 50%;
        vertical-align: middle;
      }
      &:before {
        content: "";
        display: block;
        position: absolute;
        right: 0;
        top: 50%;
        transform: translateY(-50%) rotate(45deg);
        width: 20px;
        height: 20px;
        border-top: 1px solid #b7b7b7;
        border-right: 1px solid #b7b7b7;
      }
      &:after {
        content: "";
        display: block;
        position: absolute;
        bottom: 0;
        left: 50%;
        transform: translateX(-50%);
        width: 100%;
        height: 1px;
        background-color: #f5f5f5;
      }
      &:last-child:after {
        display: none;
      }
    }
    .mobile:before {
      display: none;
    }
  }
  .popup {
    margin: 0;
    li {
      height: 92px;
      line-height: 92px;
      font-size: 34px;
      font-weight: 300;
      color: #030303;
      text-align: center;
      display: block;
      // position: relative;
      &:before {
        display: none;
      }
      input {
        position: absolute;
        top: 0;
        left: 0;
        opacity: 0;
      }
    }
  }
}
/deep/ .attrs-checkbox {
  .attrs-checkbox-btn {
    display: flex;
    justify-content: space-between;
    color: $theme_color;
    font-size: 28px;
    border-bottom: 1px solid #f5f5f5;
    height: 80px;
    p {
      width: 80px;
      height: 80px;
      text-align: center;
      line-height: 80px;
    }
  }
  .attrs-checkbox-content {
    padding: 20px;
    .van-checkbox {
      height: 80px;
    }
    .van-checkbox__label {
      margin-left: 20px;
    }
  }
}
</style>